import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import merchantCart from './modules/merchantCart'
import promoCart from './modules/promoCart'
import page from './modules/page'
import assignmentSingle from './modules/assignmentSingle'
import assignmentFamily from './modules/assignmentFamily'
import assignmentFamilyPlus from './modules/assignmentFamilyPlus'

Vue.use(Vuex)

/* eslint-disable no-new */
const store = new Vuex.Store({
  strict: true,
  modules: {
    cart,
    merchantCart,
    promoCart,
    page,
    assignmentSingle,
    assignmentFamily,
    assignmentFamilyPlus
  }
})

export default store
